import medicaidCertificationRoutes from './medicaid-certification.route';

const routes = [
  {
    path: 'medicaid',
    component: () => import('@/views/medicaid/Wrapper.vue'),
    children: [
      {
        path: '/medicaid/menu',
        name: 'medicaid',
        component: () => import('@/views/medicaid/Menu.vue'),
      },
      medicaidCertificationRoutes,
    ],
  },
];

export default routes;
